// @flow

import React from 'react';
import ReactDOM from 'react-dom';

import ProductPage from './components/ProductPage';
import SettingsActions from './actions/SettingsActions';
//import SettingsStore from './stores/SettingsStore';
import ConfigPage from './components/ConfigPage';
import SoftwareUpdatePage from "./components/SoftwareUpdatePage";
import Legacy from './Legacy';
import WebApi from './WebApi';
import * as serviceWorker from './serviceWorker';
import * as util from "./util";
import * as drow from "./Grobot/Drow";

// Load in module classes
import Settings from "./Grobot/Settings";
import Alarms from "./Grobot/Alarms";
import Archive from "./Grobot/Archive";
import Graph from "./Grobot/Graph";
import LoadingGraph from "./Grobot/LoadingGraph";
import Wagons from "./Grobot/Wagons";
import NominalGraph from "./Grobot/NominalGraph";
import WagonConf from "./Grobot/WagonConf";
import Tolerances from "./Grobot/Tolerances";

import {menu_translate, clear_old_page} from "./Grobot/Global";
import AppConfig from "./config";
import {activateMenuItem, getCurrentPage} from "./util";
import {setLanguageIdx, trans} from "./trans";
import DiagnosticsPage from "./components/DiagnosticsPage";
import rootStore from "./stores";
import RootContext from "./RootContext";
import AuthUser from "./components/AuthUser";


function reactMakeProductPage() {
    reactMakePage('ncp2gr', ProductPage);
}

function reactMakeConfigPage() {
    reactMakePage('admin', ConfigPage);
}

function reactMakeDiagnosticsPage() {
    reactMakePage('admin', DiagnosticsPage);
}

function reactMakeSoftwareUpdatePage() {
    reactMakePage('admin', SoftwareUpdatePage);
}

function reactMakePage(menuItem: string, Page: React.Component) {
    menu_translate();
    clear_old_page();
    activateMenuItem(menuItem);
    reactRenderComponent("content", Page);

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: http://bit.ly/CRA-PWA
    serviceWorker.unregister();
}

function reactRenderComponent(elementId: string, Comp: React.Component, props: ?{} = null) {
    if (props == null) props = {};
    ReactDOM.render(<Comp {...props} />, document.getElementById(elementId));
}

function reactLogout() {
    console.log("reactLogout(): invalidating session");
    rootStore.sessionStore.invalidate();
    window.location.reload();
}

Legacy.debug(`KLPMS UI: ${process.env.REACT_APP_NAME} ${process.env.REACT_APP_VERSION}`);
Legacy.debug(`BASE_URL: ${AppConfig.BASE_URL}`);

Legacy.setGlobal('ReactDOM', ReactDOM);
Legacy.setGlobal('reactMakeProductPage', reactMakeProductPage);
Legacy.setGlobal('reactMakeConfigPage', reactMakeConfigPage);
Legacy.setGlobal('reactMakeDiagnosticsPage', reactMakeDiagnosticsPage);
Legacy.setGlobal('reactMakeSoftwareUpdatePage', reactMakeSoftwareUpdatePage);
Legacy.setGlobal('reactLogout', reactLogout);
Legacy.setGlobal('SettingsActions', SettingsActions);
Legacy.setGlobal('util', util);
Legacy.setGlobal("correct_grid_row", drow.correct_grid_row);
Legacy.setGlobal("convert_data_format", drow.convert_data_format);
Legacy.setGlobal("convert_data_row", drow.convert_data_row);
Legacy.setGlobal("limit_timestamp", util.limit_timestamp);
Legacy.setGlobal("activateMenuItem", util.activateMenuItem);
Legacy.setGlobal("getURLParameter", util.getURLParameter);
Legacy.setGlobal("getCurrentPage", util.getCurrentPage);
Legacy.setGlobal("setLanguageIdx", setLanguageIdx);
Legacy.setGlobal("trans", trans);

// Init modules:
Legacy.setGlobal("settings", Settings.getInstance());
Legacy.setGlobal("alarms", Alarms.getInstance());
Legacy.setGlobal("archive", Archive.getInstance());
Legacy.setGlobal("graph", Graph.getInstance());
Legacy.setGlobal("loadinggraph", LoadingGraph.getInstance());
Legacy.setGlobal("wagons", Wagons.getInstance());
Legacy.setGlobal("nominalGraph", NominalGraph.getInstance());
Legacy.setGlobal("wagonConf", WagonConf.getInstance());
Legacy.setGlobal("tolerances", Tolerances.getInstance());

WebApi.url(AppConfig.BASE_URL);

if (document.getElementById("modal") != null) {
    let role = "user";
    if(getCurrentPage() == "archive.html") role = "archive";
    rootStore.sessionStore.setRequiredRole(role);
    reactRenderComponent("modal", AuthUser);
}
